import React from 'react';

function victor() {
    return(
        <>
            <section id="crew-container">
                <h2 id="crew-title">
                    PILOT
                </h2>
                <h3 id="crew-name">
                    VICTOR GLOVER
                </h3>
                <p id="information" className="crew-info">
                    Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. 
                    Glover is a commander in the U.S. Navy where he pilots an F/A-18. He was a crew member of Expedition 64, 
                    and served as a station systems flight engineer.
                </p>
            </section>
        </>
    );
}

export default victor;